import Swiper, { Pagination } from 'swiper'

import './news.scss'

const selectors = {
  container: '[data-news]',
  dropdown: '[data-news-dropdown]',
  dropdownHeader: '[data-news-dropdown-header]',
  tab: '[data-news-tab]',
  tabActive: '[data-news-tab-active]',
  pane: '[data-news-pane]',
  active: 'active',
}

const handleDropdownClick = (dropdown) => {
  dropdown.classList.toggle(selectors.active)
}

const handleClickOutside = (e, dropdown) => {
  if (!dropdown.contains(e.target) && dropdown.classList.contains(selectors.active)) {
    handleDropdownClick(dropdown)
  }
}

const handleTabClick = (activeIndex, tabs, panes, tabActive) => {
  panes.forEach((pane, index) => pane.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))
  tabs.forEach((tab, index) => {
    const isActive = index === activeIndex

    tab.classList[isActive ? 'add' : 'remove'](selectors.active)

    if (isActive) {
      tabActive.innerText = tab.firstElementChild.innerText.trim()
    }
  })
}

const initValuePropositions = (container) => {
  const tabActive = container.querySelector(selectors.tabActive)
  const tabs = container.querySelectorAll(selectors.tab)
  const panes = container.querySelectorAll(selectors.pane)
  const dropdown = container.querySelector(selectors.dropdown)
  const dropdownHeader = dropdown?.querySelector(selectors.dropdownHeader)

  document.addEventListener('click', (e) => handleClickOutside(e, dropdown))
  dropdownHeader?.addEventListener('click', () => handleDropdownClick(dropdown))
  tabs?.forEach((tab, index) =>
    tab.addEventListener('click', () => {
      handleTabClick(index, tabs, panes, tabActive)
      handleDropdownClick(dropdown)
    })
  )

  panes?.forEach((pane, index) => {
    const pages = pane.querySelectorAll('[data-page-index]')
    const buttons = pane.querySelectorAll('[data-page-button]')

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        buttons.forEach((b) => (b.dataset.state = ''))
        pages.forEach((p) => (p.dataset.state = ''))
        const page = Array.from(pages).find((p) => p.dataset.pageIndex === button.dataset.pageButton)

        if (page) {
          page.dataset.state = 'active'
        }
        button.dataset.state = 'active'
      })
    })
  })

  handleTabClick(0, tabs, panes, tabActive)
}

const initIndustriesSwiper = () => {
  new Swiper('.news__swiper.swiper', {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 8,

    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      el: '.news__swiper-pagination.swiper-pagination',
    },

    breakpoints: {
      768: {
        enabled: false,
        spaceBetween: 0,
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  const containers = document.querySelectorAll(selectors.container)

  containers?.forEach(initValuePropositions)

  // initIndustriesSwiper()
})
